import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import "../../assets/css/faq.css"
import Footer from "../components/footer"
import { createGlobalStyle } from "styled-components"
import Menu from "./menu"
import { Form, Input, Modal, Select, Button } from "antd"
import { BaseUrl } from "../utils/config"
import { useNavigate } from "@reach/router"
import {
  BrowserRouter as Router,
  Link,
  useHistory,
  useLocation
} from "react-router-dom"
import axios from "axios"
import swal from "sweetalert"
import moment from "moment"
import { useDispatch } from "react-redux"
import { setConnectedWallet, updateUserDetailsRedux } from "../../redux/actions"

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`

const HowItWorks = () => {
  const user = localStorage.getItem("loginUser")
  const [allproducts, setAllproducts] = useState([])
  const [viewProduct, setViewProduct] = useState(false)
  const [activeTab, SetActiveTab] = useState(-1)
  const loginUserMail = localStorage.getItem("loginUserMail")
  const history = useHistory()
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const panels = [
    {
      label: "1. Seriously, Don't Use Icon Fonts",
      content:
        'Icons are everywhere. These "little miracle workers" (as John Hicks described them) help us reinforce meaning in the interfaces we design and build. Their popularity in web design has never been greater; the conciseness and versatility of pictograms in particular make them a lovely fit for displays large and small. But icons on the web have had their fair share of challenges.'
    },
    {
      label: "2. Screen Readers Actually Read That Stuff",
      content:
        'Most assistive devices will read aloud text inserted via CSS, and many of the Unicode characters icon fonts depend on are no exception. Best-case scenario, your "favorite" icon gets read aloud as "black favorite star." Worse-case scenario, it\'s read as "unpronounceable" or skipped entirely.'
    },
    {
      label: "2. They Fail Poorly and Often",
      content:
        'When your icon font fails, the browser treats it like any other font and replaces it with a fallback. Best-case scenario, you\'ve chosen your fallback characters carefully and something weird-looking but communicative still loads. Worse-case scenario (and far more often), the user sees something completely incongruous, usually the dreaded "missing character" glyph.'
    },
    {
      label: "4. They're a Nightmare if You're Dyslexic",
      content:
        "Many dyslexic people find it helpful to swap out a website's typeface for something like OpenDyslexic. But icon fonts get replaced as well, which makes for a frustratingly broken experience."
    },
    {
      label: "5. There's Already a Better Way",
      content:
        "SVG is awesome for icons! It's a vector image format with optional support for CSS, JavaScript, reusability, accessibility and a bunch more. It was made for this sort of thing."
    }
  ]

  useEffect(() => {
    axios
      .get(`${BaseUrl}/product/get`)
      .then(response => {
        setAllproducts(response.data.data)
        if (response.status == 200) {
          setAllproducts(response.data.data)
        } else if (response.status == 401) {
          dispatch(updateUserDetailsRedux({}))
          dispatch(setConnectedWallet(""))
          localStorage.clear()
          navigate("/login")
        } else if (response.status == 404) {
          swal({
            title: "Error!",
            text: "Page not found. Please try again later.",
            icon: "error"
          })
        } else if (response.status == 500) {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        } else if (response.status == 503) {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        } else {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        }
      })
      .catch(error => {
        if (error?.response?.status === 401) {
          localStorage.clear()
          dispatch(updateUserDetailsRedux({}))
          navigate("/login")
        } else
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
      })
  }, [])

  const onviewproduct = id => {
    setViewProduct(true)
    // SetSelectedId(id);
    navigate("/productdetails", { state: { selectedId: id } })
  }
  const toLogin = () => {
    navigate("/login")
  }
  const toChangePage = item => {
    navigate(`/${item}`)
  }
  const activateTab = index => {
    activeTab === index ? SetActiveTab(-1) : SetActiveTab(index)
  }
  return (
    <div className="">
      {/* <GlobalStyles/> */}
      <section className="jumbotron less-padding-in-mobile  no-bg">
        <div className="">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center"> How It Works</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="backgroundColordark ">
        <div className=" row  pt-md-4 d-flex justify-content-center">
          <div className="accordion  w-100 remove-max-width" role="tablist">
            {panels.map((panel, index) => (
              <Panel
                key={index}
                activeTab={activeTab}
                index={index}
                {...panel}
                activateTab={activateTab.bind(null, index)}
              />
            ))}
          </div>
          {/* //------------------------------------------------------------------------------------------------------------ */}

          {/* <div className="accordion l-container">
                        <ul className="accordion-list">
                            <li className="accordion-item">
                                <div className="accordion-button"><span>1. What is Nesting?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <div className="accordion-button"><span>2. Why Nesting?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <div className="accordion-button"><span>3. Who is a Nester?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <div className="accordion-button"><span>4. Why should you become a Nester?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>  <li className="accordion-item">
                                <div className="accordion-button"><span>5. What are the steps for becoming a Nester?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>  <li className="accordion-item">
                                <div className="accordion-button"><span>6. How will a Nester earn?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>  <li className="accordion-item">
                                <div className="accordion-button"><span>7. Do Nesters in specific locations have more benefits?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>  <li className="accordion-item">
                                <div className="accordion-button"><span>8. Can there be multiple Nesters in the same place?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>  <li className="accordion-item">
                                <div className="accordion-button"><span>9. How will I know my Tier?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <div className="accordion-button"><span>10. What if I no longer want to be a Nester?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <div className="accordion-button"><span>11. I live in a rented premises. In case I change my address, can I still be a Nester?</span></div>
                                <div className="accordion-panel">
                                    <ul>
                                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque repellendus cupiditate corrupti, ratione odit velit obcaecati deleniti aspernatur! Explicabo eveniet nostrum numquam molestias delectus! Rem commodi dolor impedit assumenda dignissimos.</li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
        </div>
               

           
                    */}

          <div className="spacer-double"></div>

          {/* <ul className="pagination justify-content-center ">
                <li className="active"><span>1 - 20</span></li>
                <li><span>21 - 40</span></li>
                <li><span>41 - 60</span></li>
            </ul>  */}
        </div>
      </section>

      {/* <Footer /> */}
    </div>
  )
}
export default HowItWorks

class Panel extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      height: 0
    }
  }

  componentDidMount() {
    window.setTimeout(() => {
      const el = ReactDOM.findDOMNode(this)
      const height = el.querySelector(".panel__inner").scrollHeight
      this.setState({
        height
      })
    }, 333)
  }

  render() {
    const { label, content, activeTab, index, activateTab } = this.props
    const { height } = this.state
    const isActive = activeTab === index
    const innerStyle = {
      height: `${isActive ? height : 0}px`
    }

    return (
      <div className="panel" role="tabpanel" aria-expanded={isActive}>
        <button className="panel__label" role="tab" onClick={activateTab}>
          {label}
        </button>
        <div
          className="panel__inner"
          style={innerStyle}
          aria-hidden={!isActive}>
          <p className="panel__content">{content}</p>
        </div>
      </div>
    )
  }
}

class Accordion extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: 0
    }

    this.activateTab = this.activateTab.bind(this)
  }

  activateTab(index) {
    this.setState(prev => ({
      activeTab: prev.activeTab === index ? -1 : index
    }))
  }

  render() {
    const { panels } = this.props
    const { activeTab } = this.state
    return (
      <div className="accordion" role="tablist">
        {panels.map((panel, index) => (
          <Panel
            key={index}
            activeTab={activeTab}
            index={index}
            {...panel}
            activateTab={this.activateTab.bind(null, index)}
          />
        ))}
      </div>
    )
  }
}
